export class CheckinRequest {
    id: number;
    accountingId?: number;

    requestBy?: string;
    RequestTo?: string;
    RequestTime?: Date;

    isResponded?: boolean;
    isAgreed?: boolean;
    responseTime?: Date;
}
